export const HOME_SEO_META = {
    title: "Stanza — Sports, TV & entertainment calendars for your phone",
    description: "Discover and subscribe to calendars for sports, TV and entertainment. Add every game, match and show straight to your phone's calendar, automatically kept up to date.",
};
/** The app shell's static crawl-fallback nav; a frontend test keeps the two identical. */
export const HOME_CRAWL_LINKS = [
    { label: "NFL schedule calendar", path: "/tag/nfl" },
    { label: "NBA schedule calendar", path: "/tag/nba" },
    { label: "MLB schedule calendar", path: "/tag/mlb" },
    { label: "Premier League fixtures calendar", path: "/tag/premier-league" },
    { label: "Champions League fixtures calendar", path: "/tag/champions-league" },
    { label: "Women's sports calendars", path: "/tag/womens-sports" },
    { label: "Netflix release calendars", path: "/tag/netflix" },
    { label: "New England Patriots schedule", path: "/nfl-patriots/53c83ad213ae03da10daebc4" },
    { label: "Los Angeles Lakers schedule", path: "/nba-lakers/542395d790bc83984ee5bb2d" },
    { label: "Golden State Warriors schedule", path: "/nba-warriors/53ae0d467f33ed8a06bd0421" },
    { label: "FC Barcelona fixtures", path: "/barcelona/55c00c737cc2c6e42f78f873" },
    { label: "Search calendars", path: "/search" },
    { label: "Stanza for creators", path: "/creators" },
    { label: "Stanza+ pricing", path: "/upgrade/plus" },
    { label: "How Stanza works", path: "/product/how-stanza-gets-schedules" },
    { label: "Vision", path: "/vision" },
    { label: "Privacy policy", path: "/privacy" },
    { label: "Terms of service", path: "/terms" },
];
/**
 * Builds the JSON-LD graph for the homepage: the Organization (grounds the
 * knowledge panel / sitelinks identity) and the WebSite. No SearchAction —
 * Google deprecated the sitelinks search box.
 *
 * @param baseUrl - Site origin without a trailing slash.
 * @returns JSON-LD graph.
 */
export function buildHomeJsonLd(baseUrl) {
    return [
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Stanza",
            url: `${baseUrl}/`,
            logo: `${baseUrl}/logo512.png`,
        },
        {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Stanza",
            url: `${baseUrl}/`,
        },
    ];
}
//# sourceMappingURL=homePage.js.map